// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { classList } from '@Helpers/className';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import React, { MouseEventHandler, ReactElement } from 'react';

import './AddButton.scss';

interface AddButtonProps {
    label: string;
    className?: string;
    onClick?: MouseEventHandler<HTMLElement>;
    block?: boolean;
    disabled?: boolean;
}

const AddButton = ({ label, className, onClick, disabled }: AddButtonProps): ReactElement => (
    <THTooltip title={label}>
        <THButton type="default" onClick={onClick} className={classList('add-button', className)} disabled={disabled}>
            <ICONS.PlusIcon />
        </THButton>
    </THTooltip>
);

export default AddButton;
